import React from "react"
import footerStyles from "./footer.module.scss"

export default function Footer(props) {
  return <div className={footerStyles.container}><p className={footerStyles.copyright + " small"}>© {new Date().getFullYear()}
  {` `} Tesla Trips Europe</p></div>
}